export function calculateStickyOffsets(layerHeights) {
  const offsets = [];
  let totalHeight = 0;

  layerHeights.forEach((height) => {
    offsets.push(totalHeight);
    totalHeight += height;
  });

  return { offsets, totalHeight };
}
